// extracted by mini-css-extract-plugin
export default {"root":"styles-module__root--fa5Ob","content":"styles-module__content--uxyEb"};